/*
 * @Author: Chao Yang
 * @Date: 2019-09-24 06:49:27
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-03-01 08:20:36
 */
import {
  Component,
  OnInit,
  Input,
  ContentChildren,
  AfterContentInit,
  TemplateRef,
} from '@angular/core';
import {
  ActivatedRoute,
  ActivationStart,
  NavigationStart,
  Router,
} from '@angular/router';
import { MenuOption } from './model/menu-option';
import { AlterDomusTemplateDirective } from '../common/alter-domus-template/alter-domus-template.directive';

@Component({
  selector: 'ad-section-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, AfterContentInit {
  disableSticky = false;
  menuIconTemplate: TemplateRef<any>;
  menusTemplate: TemplateRef<any>;
  customTemplate: TemplateRef<any>;
  @Input()
  option: MenuOption;
  @ContentChildren(AlterDomusTemplateDirective)
  templates: AlterDomusTemplateDirective[];

  constructor(private _route: ActivatedRoute, private _router: Router) {}

  ngAfterContentInit(): void {
    this.templates.forEach((item) => {
      switch (item.getType()) {
        case 'menuIcon':
          this.menuIconTemplate = item.template;
          break;
        case 'menusTemplate':
          this.menusTemplate = item.template;
          break;
        case 'customTemplate':
          this.customTemplate = item.template;
          break;
      }
    });
  }

  ngOnInit(): void {
    let snapshot = this._route.snapshot;
    this.setSticky(snapshot.data);
    while (snapshot.firstChild !== null) {
      snapshot = snapshot.firstChild;
      this.setSticky(snapshot.data);
    }
    this._router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        this.disableSticky = false;
      }
      if (e instanceof ActivationStart) {
        this.setSticky(e.snapshot.data);
      }
    });
  }

  setSticky(data: any): void {
    if (data.sticky === true) {
      this.disableSticky = false;
    } else if (data.sticky === false) {
      this.disableSticky = true;
    }
  }
}
